(() => {
  function initFileUploads(root = document) {
    root.querySelectorAll('[data-tapn-file-upload]:not([data-tapn-file-upload-bound])').forEach((uploader) => {
      uploader.dataset.tapnFileUploadBound = 'true';

      const input = uploader.querySelector('[data-tapn-file-upload-input]');
      const trigger = uploader.querySelector('[data-tapn-file-upload-trigger]');
      const selected = uploader.querySelector('[data-tapn-file-upload-selected]');
      const selectedName = uploader.querySelector('[data-tapn-file-upload-name]');
      const selectedSize = uploader.querySelector('[data-tapn-file-upload-size]');
      const remove = uploader.querySelector('[data-tapn-file-upload-remove]');
      const error = uploader.querySelector('[data-tapn-file-upload-error]');
      const errorMessage = uploader.querySelector('[data-tapn-file-upload-error-message]');
      if (!input || !trigger || !selected || !selectedName || !selectedSize || !remove || !error || !errorMessage) return;

      const maximumSize = Number(uploader.dataset.maxFileSize) || 10485760;
      const acceptedExtensions = input.accept.split(',').map((extension) => extension.trim().toLowerCase()).filter(Boolean);

      const formatSize = (bytes) => {
        if (bytes < 1024) return `${bytes} octets`;

        const units = ['Ko', 'Mo', 'Go'];
        const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)) - 1, units.length - 1);
        const size = bytes / (1024 ** (index + 1));
        return `${size.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} ${units[index]}`;
      };

      const clearError = () => {
        error.hidden = true;
        errorMessage.textContent = '';
        trigger.classList.remove('is-invalid');
      };

      const showError = (message) => {
        errorMessage.textContent = message;
        error.hidden = false;
        trigger.classList.add('is-invalid');
      };

      const clearSelection = () => {
        input.value = '';
        selected.hidden = true;
        selectedName.textContent = '';
        selectedSize.textContent = '';
        clearError();
      };

      const validateAndShowFile = (file) => {
        if (!file) return false;

        const extension = file.name.includes('.') ? `.${file.name.split('.').pop().toLowerCase()}` : '';
        if (!acceptedExtensions.includes(extension)) {
          clearSelection();
          showError('Ce format n’est pas accepté. Choisissez un PNG, JPG, WEBP, SVG ou PDF.');
          return false;
        }

        if (file.size > maximumSize) {
          clearSelection();
          showError('Le fichier dépasse la limite de 10 Mo.');
          return false;
        }

        clearError();
        selectedName.textContent = file.name;
        selectedSize.textContent = formatSize(file.size);
        selected.hidden = false;
        return true;
      };

      const setInputFile = (file) => {
        if (!file || !validateAndShowFile(file)) return;

        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
      };

      trigger.addEventListener('click', () => input.click());
      input.addEventListener('change', () => validateAndShowFile(input.files?.[0]));
      remove.addEventListener('click', clearSelection);

      uploader.addEventListener('dragenter', (event) => {
        event.preventDefault();
        trigger.classList.add('is-dragging');
      });

      uploader.addEventListener('dragover', (event) => {
        event.preventDefault();
        trigger.classList.add('is-dragging');
      });

      uploader.addEventListener('dragleave', (event) => {
        if (uploader.contains(event.relatedTarget)) return;
        trigger.classList.remove('is-dragging');
      });

      uploader.addEventListener('drop', (event) => {
        event.preventDefault();
        trigger.classList.remove('is-dragging');

        const files = Array.from(event.dataTransfer?.files || []);
        if (files.length > 1) {
          clearSelection();
          showError('Ajoutez un seul fichier à la fois.');
          return;
        }

        setInputFile(files[0]);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFileUploads());
  else initFileUploads();

  document.addEventListener('shopify:section:load', (event) => initFileUploads(event.target));
})();
